
import './App.css';
import NavBar from './Sections/NavBar';
import Main from './Sections/Main';
import Footer from './Sections/Footer';

function App() {
  return (
    <div className="App">
      <NavBar />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
